/**
 * Create a namespace for a block using the BEM CSS naming convention
 * @param {string} block block name
 * @returns function to create element classes with block prefix
 */
export const bem = <E extends string = string, M extends string = string>(
	block: string
) => {
	/**
	 *
	 * @param {string | undefined} element
	 * @param {string | undefined} modifier
	 * @returns {string} class name
	 */
	const c = (element?: E, modifier?: M | Record<string, unknown>) => {
		let className = block;

		if (element) className += "__" + element;

		if (modifier) {
			if (modifier instanceof Object) {
				Object.entries(modifier).forEach(([key, value]) => {
					if (!!value) className += "--" + key;
				});
			} else {
				className += "--" + modifier;
			}
		}

		return className;
	};

	return c;
};
